import {
  PostApiSpoChatbotBodyMessagesItem,
  PostApiSpoChatbotRatingBody,
} from '@spo/types';
import { apiBff } from '.';

export const sendMsgToChatbot = async (
  postApiSpoChatbotBodyMessagesItem: PostApiSpoChatbotBodyMessagesItem[],
): Promise<string> => {
  return apiBff.callBFF(
    'POST',
    'spo/chatbot',
    postApiSpoChatbotBodyMessagesItem,
  );
};

export const sendFeedbackToChatbot = async (
  postApiSpoChatbotRatingBody: PostApiSpoChatbotRatingBody,
): Promise<number> => {
  return apiBff.callBFF(
    'POST',
    'spo/chatbot/rating',
    postApiSpoChatbotRatingBody,
  );
};
